import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import { CompanyLink } from '@/types/company'
import styles from './styles.module.scss'

interface CompanyRecruitLinksProps {
  links?: CompanyLink[]
  className?: string
  used?: string
}

export default function CompanyRecruitLinks({ links, className, used }: CompanyRecruitLinksProps) {
  if (!links || links.length === 0) return null

  const validLinks = links.filter((link) => link.url)

  if (validLinks.length === 0) return null

  return (
    <ul className={clsx(styles.companyLinkList, used && styles[used], className)}>
      {validLinks.map((link, index) => (
        <li key={index} className={styles.companyLinkItem}>
          <Link
            href={link.url}
            target='_blank'
            rel='noopener noreferrer'
            className={clsx('textLink', 'nonBlankIcon', styles.companyUrl)}
          >
            {link.title || link.url}
          </Link>
        </li>
      ))}
    </ul>
  )
}
